import { buildDashboardScopePayload } from "./dashboard-request-scope";

export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 20, 30, 50];
export const SEARCH_DEBOUNCE_MS = 350;
export const CATEGORY_ORDER = [
  "General",
  "Environmental",
  "Social",
  "Governance",
];
export const GROUP_BY_OPTIONS = [
  { value: "metric", label: "Metric" },
  { value: "organization", label: "Organization" },
  { value: "year", label: "Year" },
];

export const DEFAULT_SUMMARY = {
  uniqueMetrics: 0,
  assignments: 0,
};

export const DEFAULT_CATEGORY_SUMMARY = CATEGORY_ORDER.map((category) => ({
  category,
  metrics: 0,
  assignments: 0,
}));

export const DEFAULT_LIST_DATA = {
  rows: [],
  total: 0,
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  filteredAssignments: 0,
};

export const formatCount = (value) =>
  new Intl.NumberFormat().format(value || 0);

export const buildScopePayload = (filters, orgTree) => {
  return {
    years: filters.years || [],
    frameworks: filters.frameworks || [],
    categories: filters.categories || [],
    ...(filters.startYear != null &&
    filters.startMonth != null &&
    filters.endYear != null &&
    filters.endMonth != null
      ? {
          startYear: filters.startYear,
          startMonth: filters.startMonth,
          endYear: filters.endYear,
          endMonth: filters.endMonth,
        }
      : {}),
    ...buildDashboardScopePayload({ filters, orgTree }),
  };
};

const parseGroupKeyValue = (groupKey, expectedPrefix) => {
  if (!groupKey || typeof groupKey !== "string") return null;

  const [prefix, rawValue] = groupKey.split(":");
  if (prefix !== expectedPrefix || !rawValue) return null;
  return rawValue;
};

export const getAssignedMetricsGroupKey = (row) =>
  row?.groupKey || row?.key || "";

const buildDetailIdentifierPayload = (groupBy, row) => {
  const groupKey = getAssignedMetricsGroupKey(row);

  if (groupBy === "organization") {
    const organizationId =
      row.organizationId || parseGroupKeyValue(groupKey, "organization");

    if (!organizationId) {
      throw new Error("Assigned metrics detail requires organizationId.");
    }

    return { organizationId };
  }

  if (groupBy === "year") {
    const resolvedYear =
      row.year ?? Number(parseGroupKeyValue(groupKey, "year") || NaN);

    if (resolvedYear == null || Number.isNaN(Number(resolvedYear))) {
      throw new Error("Assigned metrics detail requires year.");
    }

    return { year: Number(resolvedYear) };
  }

  const metricId =
    row.metricId || row.disclosureId || parseGroupKeyValue(groupKey, "metric");

  if (!metricId) {
    throw new Error("Assigned metrics detail requires metricId.");
  }

  return { metricId };
};

export const buildAssignedMetricsDetailPayload = (
  basePayload,
  groupBy,
  row,
  options = {},
) => ({
  ...basePayload,
  groupBy,
  page: options.page ?? 1,
  pageSize: options.pageSize ?? DEFAULT_PAGE_SIZE,
  ...buildDetailIdentifierPayload(groupBy, row),
});
